import { saveAs } from 'file-saver';
import { parse } from 'json2csv';
import moment from 'moment';

import { downloadCsv } from '../../../queries/api/packaging-flow';

interface CsvParams {
    page: number;
    pageSize: number;
    differenceReported: boolean;
    packageIds: string[];
    status: string[];
    storeIds: string[];
    supplierIds: string[];
    parcPalettIds: string[];
}

export const downloadCsvFile = async (params: CsvParams) => {
    try {
        const response = await downloadCsv(params);
        const csv = parse(response, { delimiter: ';', quote: '' });
        const encoder = new TextEncoder();
        // Add BOM to the beginning of the CSV
        const bom = '\uFEFF';
        const encodedCsv = encoder.encode(bom + csv);

        const blob = new Blob([encodedCsv], { type: 'text/csv;charset=utf-8;' });

        const currentDate = new Date();
        const formattedDate = moment(currentDate).format('DD-MM-YYYY-HH:mm');

        saveAs(blob, `Flux d emballage - Export (${formattedDate}).csv`);
    } catch (error) {
        console.error('Error fetching or converting data:', error);
    }
};
